import React, { useState } from "react";
import "./contactus.scss";
import axiosInstance from "../helper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault(); // Prevent default form submission

      console.log("Form Data Submitted:", formData);
      const response = await axiosInstance.post(
        "/product/contact-us/",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(response.data, "contact");
      toast.success("Successfully sent!");

      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      toast.error("something wrong!");
    }
  };
  return (
    <div>
      <div className="contactus-container">
        <div className="note-contact" id="contact-us">
          <div className="note-main-head">Let's Talk About Your Project</div>
          <div className="note-text">
            India’s textile garments are renowned for their quality and
            craftsmanship, making them highly sought after globally. Our
            export-grade packaging ensures that every garment reaches its
            destination in perfect condition. We use advanced packaging
            materials that protect against moisture, dust, and handling damage.
            Coupled with a robust logistics network, we guarantee timely and
            efficient delivery to any part of the world.<br></br>
            <br /> Our logistics partners are experienced in handling
            international shipments, ensuring smooth customs clearance and
            delivery. From India to anywhere, we ensure that our garments not
            only meet but exceed global standards, reaching you in pristine
            condition.
          </div>
        </div>

        <div className="text-section">
          <div className="contact-text">Contact Us</div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required></textarea>
            </div>
            <button type="submit" className="cta-button">
              Send Message
            </button>
          </form>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
